export const FSRS_RATING_AGAIN = 1;
export const FSRS_RATING_HARD = 2;
export const FSRS_RATING_GOOD = 3;
export const FSRS_RATING_EASY = 4;

const VALID_FSRS_RATINGS = [
  FSRS_RATING_AGAIN,
  FSRS_RATING_HARD,
  FSRS_RATING_GOOD,
  FSRS_RATING_EASY,
];

export const isValidEasyVisibleTime = (value) =>
  Number.isFinite(value) && value > 0 && value !== 1;

export const computeEasyThresholdSecondsFromReviews = (reviews = []) => {
  const visibleTimes = (reviews ?? [])
    .map((review) => Number(review?.visible_time))
    .filter(isValidEasyVisibleTime)
    .sort((left, right) => left - right);

  if (visibleTimes.length === 0) {
    return null;
  }

  const thresholdIndex = Math.min(
    visibleTimes.length - 1,
    Math.max(0, Math.ceil(visibleTimes.length * 0.2) - 1)
  );
  return visibleTimes[thresholdIndex];
};

export const computeEasyThresholdSecondsFromHistory = (history = {}) =>
  computeEasyThresholdSecondsFromReviews(Object.values(history ?? {}).flat());

export const deriveFsrsRating = ({
  wasCorrect,
  wasActivelyFlipped,
  visibleTimeSeconds,
  easyThresholdSeconds,
}) => {
  if (!wasCorrect) {
    return FSRS_RATING_AGAIN;
  }

  if (
    Number.isFinite(visibleTimeSeconds) &&
    Number.isFinite(easyThresholdSeconds) &&
    visibleTimeSeconds < easyThresholdSeconds
  ) {
    return FSRS_RATING_EASY;
  }

  if (wasActivelyFlipped) {
    return FSRS_RATING_HARD;
  }

  return FSRS_RATING_GOOD;
};

export const getStoredOrDerivedFsrsRating = (
  review,
  easyThresholdSeconds = null
) => {
  const numericRating = Number(review?.rating);
  if (VALID_FSRS_RATINGS.includes(numericRating)) {
    return numericRating;
  }

  return deriveFsrsRating({
    wasCorrect: Boolean(review?.was_correct),
    wasActivelyFlipped: Boolean(review?.was_flipped),
    visibleTimeSeconds: Number(review?.visible_time),
    easyThresholdSeconds,
  });
};
